// Route guard: signed-in users without an org get routed to onboarding.
//
// Layered on top of RequireAuth — assumes a user is already present. Use
// it for routes that need to read or write under orgs/{orgId}; without it
// those reads would fail or hit empty state.

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useOrg } from '../../contexts/OrgContext';

export default function RequireOrg({ children }: { children: React.ReactNode }) {
  const { profile, loading } = useAuth();
  const { orgId } = useOrg();

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh', color: 'var(--muted)' }}>
        Loading…
      </div>
    );
  }

  // RequireAuth has already established a user exists; the only orgless
  // case here is "completed signup but never created an org", which is
  // every brand new user before onboarding.
  if (!profile || !orgId) {
    return <Navigate to="/onboarding/create-org" replace />;
  }

  return <>{children}</>;
}
